export enum EBinderContractTab {
  ALL_CONTRACT = 'all-contract',
  MY_CONTRACT = 'my-contract',
  CURRENT_YEAR = 'current-year',
}
